module.exports = __webpack_public_path__ + "static/screenshot4-cda0ec2ca2b18f9a207f137587b1671f.png";